import draftToHtml from 'draftjs-to-html';

import Bouncer from 'approot/shared/bouncer/bouncer';
import SimpleModalInfo from 'lib/modal/simple-modal-info';
import { getMaterialLabel } from './lesson-material.utils';
import { Materials } from './lesson-materials.constants';
import { useGetActivityMaterials } from './lesson-material.hooks';
import { LessonMaterialActivities } from './lesson-material-items';
import { LessonMaterialItem } from './lesson-material.style';
import { Box } from 'approot/shared/styles/box.style';

const LessonMaterialModal = ({
  item,
  onClose,
}: {
  item: Materials;
  onClose: () => void;
}) => {
  const isActivityMaterials = !!item.activitiesMaterials;

  const { activitiesMaterials, loading } = useGetActivityMaterials({
    lessonId: item.id,
    skip: !isActivityMaterials,
  });

  return (
    <SimpleModalInfo
      title={`${getMaterialLabel(item)} Materials`}
      isVisible
      size={700}
      dataTracking={{
        label: 'lesson-materials',
      }}
      onClose={onClose}
    >
      {isActivityMaterials ? (
        <>
          {loading ? (
            <Box $marginBottom={20}>
              <Bouncer />
            </Box>
          ) : activitiesMaterials?.length ? (
            <LessonMaterialActivities
              render={content => <div>{content}</div>}
              notes={activitiesMaterials}
              withReadMore={false}
            />
          ) : null}
        </>
      ) : (
        item.materials?.map(
          (material, index) =>
            (
              <LessonMaterialItem
                key={index}
                dangerouslySetInnerHTML={{
                  __html: draftToHtml(material),
                }}
              />
            ) || null
        )
      )}
    </SimpleModalInfo>
  );
};

export default LessonMaterialModal;
